import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import ViewQueroViajar from "../views/ViewQueroViajar";
import styled from "styled-components";
import ViewSolicitacaoReserva from "../views/ViewSolicitacaoReserva";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;



const SolicitacaoReserva: React.FC = () => (
  <>
      <ContatoZap />
    <div>
      <ViewAppBar />
    
      <ViewSolicitacaoReserva/>     
      

      <ViewFooter />
    </div>
  </>
);
export default SolicitacaoReserva;
